import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { mealPlansAPI, vendorsAPI } from "../../services/api";
import MealPlanForm from "../Vendor/MealPlanForm";
import toast from "react-hot-toast";

const CreateMealPlan = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [selectedVendorId, setSelectedVendorId] = useState(null);

  // Fetch vendors for dropdown
  const { data: vendorsData, isLoading: vendorsLoading } = useQuery(
    "vendors",
    () => vendorsAPI.getVendors(),
    { keepPreviousData: true }
  );

  const vendors = vendorsData?.data?.data?.vendors || [];

  const createMealPlanMutation = useMutation(mealPlansAPI.createMealPlan, {
    onSuccess: (data) => {
      toast.success("Meal plan created successfully!");
      queryClient.invalidateQueries("admin-meal-plans");
      navigate("/admin/meal-plans");
    },
    onError: (error) => {
      console.error("Error creating meal plan:", error);
      toast.error(
        error.response?.data?.message || "Failed to create meal plan"
      );
    },
  });

  const handleSave = async (formData) => {
    try {
      await createMealPlanMutation.mutateAsync(formData);
    } catch (error) {
      // Error is handled by the mutation's onError callback
      throw error;
    }
  };

  const handleCancel = () => {
    navigate("/admin/meal-plans");
  };

  const handleVendorChange = (vendorId) => {
    setSelectedVendorId(vendorId);
  };

  if (vendorsLoading) {
    return (
      <div style={{ padding: "2rem", textAlign: "center" }}>
        <p>Loading vendors...</p>
      </div>
    );
  }

  return (
    <MealPlanForm
      onSave={handleSave}
      onCancel={handleCancel}
      isAdmin={true}
      selectedVendorId={selectedVendorId}
      onVendorChange={handleVendorChange}
      vendors={vendors}
    />
  );
};

export default CreateMealPlan;

